import React, { useEffect, useState } from "react";
import {
  Button,
  Checkbox,
  Container,
  Divider,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  Typography,
} from "@material-ui/core";
import {
  AssignmentRounded,
  CheckBox,
  DirectionsCarRounded,
  ListRounded,
} from "@material-ui/icons";
import BaseModal, { BaseModalActions, BaseModalContent } from "../BaseModal";
import PermitContent from "../../Pages/PermitContent";
import { useSelector } from "react-redux";
import moment from "moment";
import { RouteService } from "../../../services/route.service";
import { getCustomer } from "../../../store/home/selector";
import { useHistory } from "react-router";

const useStyles = makeStyles((theme) => ({
  vehicleDiv: {
    justifyContent: "center",
  },
  activeVehicleRow: {
    background: "gray",
  },
  vehicleRow: {
    padding: "1px",
  },
  thirdStepFirstDivChild: {
    // background: "blue",
    padding: "4px",
  },
  thirdStepFirstDiv: {
    border: "1px solid black",
    background: "gray",
    borderRadius: "5px",
    boxShadow: "0px 0px 3px 1px rgba(0,0,0,0.75)",
    width: "200px",
  },
  firstStepFirstChild: {
    background: theme.palette.primary.main,
    padding: "4px",
    width: "125px",
    color: "white",
    borderRadius: "5px",
  },
  customButton: {
    borderRadius: "10px",
    backgroundColor: "#20419a",
    color: "white",
  },
  customButtons: {
    borderRadius: "10px",
  },
  mleft: {
    marginLeft: "10px",
  },
  headinText: {
    color: theme.palette.primary.main,
    fontWeight: "600",
  },
}));

export default function PermitAddedModel(props) {
  const driverViewOrderStateList = useSelector(
    (state) => state.driverViewOrderReducer.driverViewOrderStateList
  );
  const getPaymentMethodState = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitPaymentMethods
  );
  const getBuyPermitSelectedPermitsState = useSelector(
    (state) => state?.exitOrderReducer?.buyPermitSelectedPermits
  );

  const [selectedPerimtData, setSelectedPermitData] = useState(
    getBuyPermitSelectedPermitsState
  );
  const counterState = useSelector(
    (state) => state?.exitOrderReducer?.counterState
  );
  const classes = useStyles();
  const [vehicleList, setvehicleList] = useState([]);
  const [permitList, setPermitList] = useState([]);
  const [orderList, setorderList] = useState([]);
  const [allowedNoOfPermit, setAllowedNoOfPermit] = useState();
  const customerName = useSelector(getCustomer);
  const history = useHistory();

  const {
    open,
    onClose,
    permitId,
    handletoggleAddPermitPage,
    selectedPermit,
    StylingItem,
    vehicles,
    selectedDate,
    d,
    setvehicles
  } = props;
  
  const stylingVal = {
    backgroundColor: StylingItem && StylingItem.bodyColor,
    fontFamily: StylingItem && StylingItem.font,
    color: StylingItem && StylingItem.fontColor,
  };


  const validEndDate = (endDate, validDate) => {
    var isafter = moment(selectedDate).add(validDate, 'days').isAfter(endDate);
    if(!selectedDate){
      return moment(endDate)?.format("MM/DD/YYYY")
    }else if(isafter === false){
      return  moment(selectedDate).add(validDate, 'days')?.format("MM/DD/YYYY")
    }else{
      return moment(endDate)?.format("MM/DD/YYYY")
    }
  }

  // add another Permit
  const handleAnotherPermit = () => {
    setvehicles([])
    setvehicleList([])
    onClose()
    
    // history.push({
    //   pathname: RouteService.buyPermits(customerName), 
    // });
  };

  useEffect(() => {
    var allowedpmt =
      Array.isArray(getPaymentMethodState) &&
      getPaymentMethodState?.filter((itm) => {
        if (itm?.ruleType === "MAX_NUMBER_PERMIT_SALES") {
          return itm;
        }
      });
    setAllowedNoOfPermit(allowedpmt[0]?.ruleValues[0]);
  }, [counterState, getPaymentMethodState]);

  React.useEffect(() => {
    setorderList(driverViewOrderStateList);
  }, [driverViewOrderStateList]);

  function isDateGrater(date1, date2) {
    if (date1.getFullYear() > date2.getFullYear()) {
      return true;
    } else if (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() > date2.getMonth()
    ) {
      return true;
    } else if (
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() >= date2.getDate()
    ) {
      return true;
    }
    return false;
  }

  var PerchasedPermitList =
    Array.isArray(orderList) &&
    orderList?.filter((pmtOrder, i) => {
      let date1 = pmtOrder?.lines[0]?.item?.validEndDate;
      let orderDate = new Date(date1);
      let date2 = new Date();
      if (isDateGrater(orderDate, date2)) {
        return pmtOrder?.lines[0]?.item;
      }
    });

  useEffect(() => {
    setvehicleList(vehicles);
    
  }, [vehicles]);

  useEffect(() => {
    setSelectedPermitData(getBuyPermitSelectedPermitsState);
  }, [getBuyPermitSelectedPermitsState]);
  var item_qty = 0;
  return (
    <BaseModal
      title="Permit Added"
      align="center"
      open={open}
      onClose={onClose}
      icon={<AssignmentRounded />}
      fullWidth
      style={stylingVal && stylingVal}
    >
      <BaseModalContent>
        <>
          <div className="d-flex contentwrapper" tabIndex='0'>
            <PermitContent permit={d} />
            <div className="text-left">
              {/* <p className="headinText"> */}

              <div>
                <p className={classes.headinText}>
                  {`${d?.name}`} &nbsp; &nbsp;
                  {/* <b>{selectedPermit?.permitType}</b> */}
                </p>
              </div>
              <p>
                {/* {`Good from ${moment(
                  //selectedPermit?.validStartDate
                  selectedDate ? selectedDate : selectedPermit?.validStartDate
                  )?.format(
                  "MM/DD/YYYY"
                )} to ${moment(selectedPermit?.validEndDate)?.format(
                  "MM/DD/YYYY"
                )}`} */}
                            Good from{" "}
                            {moment(
                              // selectedPermit?.validStartDate
                              selectedDate ? selectedDate : d?.validStartDate
                              // d?.validStartDate ? d?.validStartDate :   selectedDate
                              )?.format(
                              "MM/DD/YYYY"
                            )}{" "}
                            to{" "} {validEndDate(d?.validEndDate, d?.validDays)}
              </p>
              <p>${d && d?.price?.toFixed(2)}</p>
              <p>{d?.allowedNoVehicles} Vehicle Limit</p>
            </div>
          </div>
        </>

        <div className="ddflex g40" style={{ marginTop: 10 }}>
          <Button
            className={classes.customButton}
            variant={"contained"}
            // color="primary"
            onClick={ handleAnotherPermit}
            // onClick={handleAnotherPermit}
            disabled={true}
            // disabled={
            //   (PerchasedPermitList &&
            //     PerchasedPermitList?.length + selectedPerimtData?.length) >=
            //   allowedNoOfPermit
            //     ? true
            //     : false
            // }
          >
            Add another permit
          </Button>
          <Button
            variant={"outlined"}
            className={classes.customButtons}
            onClick={(e) => handletoggleAddPermitPage("view")}
          >
            View cart
          </Button>
        </div>
      </BaseModalContent>
    </BaseModal>
  );
}
